import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import pluralize from 'pluralize';

import useAdminPurchasedCustomPrintConfigurator from './hooks/useAdminPurchasedCustomPrintConfigurator';
import DesignEditorHeader, {
  DesignEditorHeaderCenterSlot,
} from '../../../../components/global/DesignEditor/components/DesignEditorHeader';
import DesignEditor from '../../../../components/global/DesignEditor';
import DesignEditorLoadingIndicator from '../../../../components/global/DesignEditor/components/DesignEditorLoadingIndicator';
import AdminPurchasedCustomPrintConfiguratorPreviewPane from './components/AdminPurchasedCustomPrintConfiguratorPreviewPane';

const AdminPurchasedCustomPrintConfigurator = () => {
  const match = useRouteMatch();
  const { purchasedCustomPrintId } = match?.params ?? {};
  const {
    loading,
    albumCustomPrint,
    accountCardConfiguration: {
      loadingAccountCard,
      accountCard,
      onElementConfigurationChange,
      cardElementLoading,
    },
  } = useAdminPurchasedCustomPrintConfigurator({
    purchasedCustomPrintId,
  });

  if (loading || !albumCustomPrint || !accountCard) {
    return <DesignEditorLoadingIndicator />;
  }

  return (
    <DesignEditor>
      <DesignEditorHeader>
        <DesignEditorHeaderCenterSlot>
          <h3 className="design-editor-header-title">
            Configure {pluralize(albumCustomPrint.name, 1)}
          </h3>
        </DesignEditorHeaderCenterSlot>
      </DesignEditorHeader>
      <AdminPurchasedCustomPrintConfiguratorPreviewPane
        accountCard={accountCard}
        loading={loadingAccountCard}
        onElementConfigurationChange={onElementConfigurationChange}
        cardElementLoading={cardElementLoading}
      />
    </DesignEditor>
  );
};

export default AdminPurchasedCustomPrintConfigurator;
